/** Rotate image by 90-degree increments. direction: 1 = CW, -1 = CCW */
export function rotate90(source: ImageData, direction: 1 | -1): ImageData {
  const { width: sw, height: sh, data: src } = source;
  const dw = sh;
  const dh = sw;
  const output = new ImageData(dw, dh);
  const dst = output.data;

  for (let y = 0; y < sh; y++) {
    for (let x = 0; x < sw; x++) {
      const si = (y * sw + x) * 4;
      let dx: number, dy: number;
      if (direction === 1) {
        // CW: (x, y) -> (sh - 1 - y, x)
        dx = sh - 1 - y;
        dy = x;
      } else {
        // CCW: (x, y) -> (y, sw - 1 - x)
        dx = y;
        dy = sw - 1 - x;
      }
      const di = (dy * dw + dx) * 4;
      dst[di] = src[si];
      dst[di + 1] = src[si + 1];
      dst[di + 2] = src[si + 2];
      dst[di + 3] = src[si + 3];
    }
  }
  return output;
}

/** Free rotation by arbitrary angle (degrees) using offscreen canvas */
export function rotateFree(source: ImageData, angleDeg: number): ImageData {
  if (angleDeg === 0) return source;

  const angleRad = (angleDeg * Math.PI) / 180;
  const cos = Math.abs(Math.cos(angleRad));
  const sin = Math.abs(Math.sin(angleRad));
  const sw = source.width;
  const sh = source.height;
  const nw = Math.ceil(sw * cos + sh * sin);
  const nh = Math.ceil(sw * sin + sh * cos);

  // Source canvas
  const srcCanvas = new OffscreenCanvas(sw, sh);
  const srcCtx = srcCanvas.getContext('2d')!;
  srcCtx.putImageData(source, 0, 0);

  // Destination canvas
  const dstCanvas = new OffscreenCanvas(nw, nh);
  const dstCtx = dstCanvas.getContext('2d')!;
  dstCtx.translate(nw / 2, nh / 2);
  dstCtx.rotate(angleRad);
  dstCtx.drawImage(srcCanvas, -sw / 2, -sh / 2);

  return dstCtx.getImageData(0, 0, nw, nh);
}
